import * as api from '../../api/api';
import { Options } from '../../api/api';
import { SearchResults, GetURLParams } from '../../types/search';
import { IMenuData, navStore } from '../../webcomponents/exposed-nav/store';

export type SearchSuggestionsApiResponse = SearchResults | null;

export const SEARCH_SUGGESTIONS_API = {
    uri: '/api/cars/suggestions?keyword='
};

export const getUrl = ({ search, params = '', userId }: GetURLParams): string =>
    SEARCH_SUGGESTIONS_API.uri + encodeURIComponent(search) + (params ? `&${params}` : '') + (userId ? `&userid=${userId}` : '');

export const getSearchSuggestions = (
    search: string,
    params: string,
    done: (searchSuggestionsApiResponse: SearchResults | null) => any
) => {
    const { userId } = navStore.getState() as IMenuData;
    const options: Options = {
        url: getUrl({ search, params, userId }),
        withCredentials: true
    };
    api.get(
        options,
        function success(res) {
            done(res);
        },
        function error(e) {
            console.error('Error fetching search suggestions: ', e);
            done(null);
        }
    );
};
